/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import GetStartedSection from "./GetStartedSection.container";

export default GetStartedSection;
